// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File manager */
.file-manager-container {
    width: 100%;
    height: 100%;
    background: #fff;
    height: 650px;
    display: flex;
    flex-direction: column;
}

/* File manager body */
.file-manager__body {
    height: 100%;
    width: 100%;

    border: 1px solid #dee2e6;
    border-top: 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    display: flex;
    flex-direction: row;
    box-sizing: border-box;
}

/* Files */
th, td {
    border: none !important;
}
.file-manager__body-files {
    width: 100%;
}

.file-manager__body-files__toolbar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    border-bottom: 1px solid #dee2e6;

    padding: 2.5px 0;
    height: 34px;
}

.file-manager__body-files__toolbar .search {
    padding: 0 16px;
}

.file-manager__body-files__toolbar .input-group-addon {
    background-color: transparent;
    padding-right: 0;
}

.form-control:focus {
    box-shadow: none;
    border-color: #ccc;
}

/* Outras */
.file-manager__body-files__table {
    height: 575px;
    overflow-y: auto;
}

.file-manager__body-files__table .table {
    width: 100%;
}

.file-manager__body-files__table .table th {
    height: 32px;
}

.file-manager__body-files__table .table td {
    height: 34px;
}

.file-browser {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 8px;
    padding: 16px;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    position: relative;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
}

.file-image {
    max-width: 100%;
    max-height: 80vh;
}

.selection-rect {
    pointer-events: none;
    z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./app/src/js/components/filemanager/file-browser.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,WAAW;;IAEX,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;;IAE/B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,UAAU;AACV;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;;IAEnB,WAAW;IACX,gCAAgC;;IAEhC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,aAAa;AACjB","sourcesContent":["/* File manager */\n.file-manager-container {\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    height: 650px;\n    display: flex;\n    flex-direction: column;\n}\n\n/* File manager body */\n.file-manager__body {\n    height: 100%;\n    width: 100%;\n\n    border: 1px solid #dee2e6;\n    border-top: 0;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n}\n\n/* Files */\nth, td {\n    border: none !important;\n}\n.file-manager__body-files {\n    width: 100%;\n}\n\n.file-manager__body-files__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n\n    width: 100%;\n    border-bottom: 1px solid #dee2e6;\n\n    padding: 2.5px 0;\n    height: 34px;\n}\n\n.file-manager__body-files__toolbar .search {\n    padding: 0 16px;\n}\n\n.file-manager__body-files__toolbar .input-group-addon {\n    background-color: transparent;\n    padding-right: 0;\n}\n\n.form-control:focus {\n    box-shadow: none;\n    border-color: #ccc;\n}\n\n/* Outras */\n.file-manager__body-files__table {\n    height: 575px;\n    overflow-y: auto;\n}\n\n.file-manager__body-files__table .table {\n    width: 100%;\n}\n\n.file-manager__body-files__table .table th {\n    height: 32px;\n}\n\n.file-manager__body-files__table .table td {\n    height: 34px;\n}\n\n.file-browser {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    gap: 8px;\n    padding: 16px;\n}\n\n.popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.popup-content {\n    background: white;\n    padding: 20px;\n    border-radius: 5px;\n    position: relative;\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: red;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    padding: 5px 10px;\n    cursor: pointer;\n}\n\n.file-image {\n    max-width: 100%;\n    max-height: 80vh;\n}\n\n.selection-rect {\n    pointer-events: none;\n    z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
